import { Star } from "lucide-react";

/** Stars — compact, accessible display of a rating 0..5 (supports halves). */
export default function Stars({ value = 0, count, size = 14, className = "", showCount = true, testId }) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  const full = Math.floor(v);
  const hasHalf = v - full >= 0.25 && v - full < 0.75;
  const filled = hasHalf ? full : Math.round(v);
  const halfIndex = hasHalf ? full : -1;

  return (
    <div
      className={`inline-flex items-center gap-1.5 ${className}`}
      data-testid={testId || "stars"}
      aria-label={`Rated ${v.toFixed(1)} out of 5${count ? ` from ${count} review${count === 1 ? "" : "s"}` : ""}`}
    >
      <div className="inline-flex">
        {[0, 1, 2, 3, 4].map((i) => {
          const isFull = i < filled;
          const isHalf = i === halfIndex;
          return (
            <span key={i} className="relative" style={{ width: size, height: size }}>
              <Star
                size={size}
                strokeWidth={1.5}
                className="text-terra"
                fill={isFull ? "currentColor" : "none"}
              />
              {isHalf && (
                <span className="absolute inset-0 overflow-hidden" style={{ width: size / 2 }}>
                  <Star size={size} strokeWidth={1.5} className="text-terra" fill="currentColor" />
                </span>
              )}
            </span>
          );
        })}
      </div>
      {showCount && count != null && (
        <span className="text-xs text-ink-muted font-sans">
          {v.toFixed(1)} · {count} review{count === 1 ? "" : "s"}
        </span>
      )}
    </div>
  );
}
